import React, { useContext } from "react";
import { LangContext } from "../../../../context/lang/LangContext";
import { useAboutUs } from "../hooks/useAboutUs";
import { PhosphorIcon } from "../../../PhosphorIcon/PhosphorIcon";
import { Icons } from "../../../PhosphorIcon/types";

export const FormA = () => {
  const { messages } = useContext(LangContext);
  const { email, handleInputChange, handleSubmit, isValidEmail } = useAboutUs();

  return (
    <div className="AboutUs_formA">
      <h1 className="AboutUs_formA__Title">
        {messages.sections.aboutUs.formA.title}
        <span className="AboutUs_formA__Title_2">
          {messages.sections.aboutUs.formA.title2}
        </span>
      </h1>
      <p className="AboutUs_formA__subtitle">
        <b>{messages.sections.aboutUs.formA.subtitle}</b>
        {messages.sections.aboutUs.formA.bold1}
      </p>
      <form onSubmit={handleSubmit} className="AboutUs_formA__form">
        <input
          className="AboutUs_formA__input"
          type="text"
          placeholder={messages.sections.aboutUs.input}
          onChange={handleInputChange}
          value={email}
        />
        <button
          className="Landing__button AboutUs_formA__button"
          disabled={!isValidEmail}
        >
          <span>{messages.sections.aboutUs.formA.button}</span>
          <PhosphorIcon icon={Icons.ArrowRight} size={24} />
        </button>
      </form>
    </div>
  );
};
